// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".progress-circular--center[data-v-a90f8522]{margin-top:18%;margin-left:50%;transform:translateX(-50%)}.ptz[data-v-a90f8522]{position:relative;width:inherit;height:inherit;top:0;left:0;background-color:#000}.ptz-home-button[data-v-a90f8522]{width:175px;height:64px!important;padding:0 16px;background:#099 0 0 no-repeat padding-box;opacity:1;font:normal normal 700 24px/32px Segoe UI;letter-spacing:0}.ptz-home-button--layout[data-v-a90f8522]{position:absolute;bottom:10px;right:5%}", ""]);
// Exports
module.exports = exports;
